
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/company",
      function () {
        return require("private-next-pages/about-us/company.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/company"])
      });
    }
  